import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { APIService } from "src/app/api/api.service";
import { NotifierService } from "src/app/_services/notifier.service";

@Component({
  selector: "app-patching-history",
  templateUrl: "./patching-history.component.html",
  styleUrls: ["./patching-history.component.css"],
})
export class PatchingHistoryComponent implements OnChanges {
  @Input() accountId: string = "";
  @Input() environmentOptions: string[] = [];
  @Output() hideModal = new EventEmitter<boolean>();

  loading = false;
  items: any[] = [];
  count = 0;
  errorMessage = "";
  editingItem: any = null;

  constructor(
    private apiServer: APIService,
    private notifier: NotifierService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["accountId"]?.currentValue) {
      this.cancelEdit();
      this.loadHistory();
    }
  }

  async loadHistory() {
    if (!this.accountId) {
      this.items = [];
      this.count = 0;
      return;
    }

    this.loading = true;
    this.notifier.loading(true);
    this.errorMessage = "";

    const apiURL = `https://dev.api.swayam.cloud/v3/admin/apis/patching-fetch-save-config?awsAccountId=${this.accountId}&limit=50`;
    const header = {
      Authorization: localStorage.getItem("t"),
    };

    const result = await this.apiServer.getDataPromis(apiURL, {}, header);

    if (result?.status === "success") {
      this.items = result.items || [];
      this.count = result.count || this.items.length;
    } else {
      this.items = [];
      this.count = 0;
      this.errorMessage =
        result?.error || result?.msg || "Unable to load patching information.";
    }

    this.loading = false;
    this.notifier.loading(false);
  }

  close() {
    this.hideModal.emit(true);
  }

  startEdit(item: any) {
    this.editingItem = item;
  }

  cancelEdit() {
    this.editingItem = null;
  }

  handleUpdated(updatedItem: any) {
    const index = this.items.findIndex(
      (item: any) =>
        item.hostname === this.editingItem?.hostname &&
        item.instance_id === this.editingItem?.instance_id
    );

    if (index > -1) {
      this.items[index] = {
        ...this.items[index],
        ...updatedItem,
        to_email_communication:
          updatedItem?.to_email_communication ??
          this.items[index].to_email_communication,
        cc_email_communication:
          updatedItem?.cc_email_communication ??
          this.items[index].cc_email_communication,
      };
    }

    this.cancelEdit();
  }

  normalizeEmailsForInput(value: any) {
    if (!value) {
      return "";
    }

    if (Array.isArray(value)) {
      return value.join(", ");
    }

    const rawValue = String(value).trim();
    if (rawValue.startsWith("[") && rawValue.endsWith("]")) {
      return rawValue
        .replace(/^\[/, "")
        .replace(/\]$/, "")
        .replace(/'/g, "")
        .split(",")
        .map((email: string) => email.trim())
        .filter((email: string) => !!email)
        .join(", ");
    }

    return rawValue;
  }

  formatEmailsForDisplay(value: any) {
    const normalized = this.normalizeEmailsForInput(value);
    return normalized || "-";
  }
}
